import CreditCardForm from 'app/components/Core/CreditCard/Form'
import { PaymentTypeEnum } from 'app/constants/Enums'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { PaymentContainerProps } from './typing'

const CreditCard = ({ quote, portalId }: PaymentContainerProps) => {
  const navigate = useNavigate()
  const { parameterize } = ToolBox

  const onSuccess = () => {
    navigate(
      {
        pathname: Routes.Payment.member(String(quote?.rental?.id)).confirmation,
        search: parameterize({ payment_option: PaymentTypeEnum.credit_card })
      },
      { replace: true }
    )
  }

  return (
    <React.Fragment>
      <CreditCardForm member={{ quote_id: quote?.id }} props={{ portalId, onSuccess }} />
    </React.Fragment>
  )
}

export default CreditCard
